import React from 'react';
import articlePageHelper from 'shared/routes/article';

import Layout from 'desktop/components/Layout';
import LINKS from 'desktop/constants/navigation';

import ArticleLeasing from './ArticleLeasing';

const renderArticleByTemplate = (template, params) => (
  // if (template === 'Leasing')
  //  return <ArticleLeasing specialCars={specialCars} content={content} h1={h1} />
  // else return <ArticleLeasing specialCars={specialCars} content={content} h1={h1} />
  <ArticleLeasing
    content={params.content}
    h1={params.h1}
    specialCars={params.specialCars}
    breadcrumbsLinks={params.breadcrumbsLinks}
    advertsFilter={params.advertsFilter}
    searchLink={params.searchLink}
    categories={params.categories}
    titles={params.titles}
  />
);

async function action(params) {
  const { baseUrl, path } = params;
  const url = `${baseUrl}${path}`.replace('//', '/');

  const pageParams = await articlePageHelper(params);
  const { slug, title, description, template, ...otherParams } = pageParams;

  if (!slug) return null;

  return {
    chunks: ['articles'],
    title,
    description,
    shouldSetNoIndex: false,
    shouldSetIndex: true,
    component: (
      <Layout navLinks={LINKS.JOURNAL} currentRoute={url} footer="leasing">
        {renderArticleByTemplate(template, otherParams)}
      </Layout>
    ),
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/desktop/routes/articles/index.js